import Vue from 'vue'
import get from 'lodash/get'

import * as Types from './types'

export default {
  [Types.SET_COMPLETION]: (state, { contentType, id, status }) => {
    if (!state[contentType]) {
      Vue.set(state, contentType, {})
    }

    const date = new Date().toISOString()

    const currentStatus = get(state, [contentType, id], {})

    Vue.set(state[contentType], id, Object.assign({}, currentStatus, status, { date }))
  },
  [Types.RESET_STATE]: state => {
    Vue.set(state, 'lesson', {})
    Vue.set(state, 'quiz', {})
    Vue.set(state, 'tasting', {})
    Vue.set(state, 'tasting-question', {})
  }
}
